import axios from 'axios';
import store from '@/store';
import cookiesHandler from './cookiesHandler';
import AuthUserService from '@/services/AuthUserService';
import urlHandler from './urlHandler';

const requestHandler = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        'Accept': 'application/json',
        "Content-Type": "application/json"
    },
    // withCredentials: true,
});

requestHandler.interceptors.request.use(
    config => {
        const token = cookiesHandler.getEncryptedCookie('TM_TOKEN');
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      },
      error => {
        return Promise.reject(error);
    }
);

requestHandler.interceptors.response.use(
    response => response,
    error => {
        if (error.response == undefined) {
            return {
                success: false,
                data: {},
                message: 'a problem occurred with your application, but do not worry, we are already looking into it',
                status: 900,
            };
        }else{
            throw error;
        }
    }
);

/**
 * Functions
 */
requestHandler.baseUrl = function getBaseUrl(){
    return requestHandler.defaults.baseURL;
}
requestHandler.makeUrl = function makeUrl(uri){
    return requestHandler.defaults.baseURL + uri;
}
/**
 * Perform an AXIOS request
 * @param {String} url 
 * @param {Object} parameters 
 * @param {String} method - 'post', 'get', 'put' or 'delete'
 * @param {Object} header
 * @returns {
 *  success: Boolean,
 *  data: requestResult
 *  status: integer
 * }
 */
requestHandler.executeRequest = async function executeRequest(url, parameters = {}, method = 'post', options = {}){
    let resultFormat = {
        success: true,
        data: {},
        message: '',
        status: 200,
        header: {}
    };
        
    parameters['user_lang'] = store.getters.getUserLang;
    let parametersAsArray = Object.keys(parameters);

    let optionsOfRequest = {
        params: parameters,
        responseType: options['responseType'] != undefined ? options['responseType'] : 'json'
    }
    if(method != 'get')
        delete optionsOfRequest.params;
    if(options['headers'] != undefined)
        optionsOfRequest['headers'] = options['headers'];
    try {
        let response = null;
        switch(method){
            case 'post':
                response = await this.post(url, parameters, optionsOfRequest);
            break;
            case 'get':
                if(parametersAsArray.length > 0){
                    url += '?';
                    for(let key of parametersAsArray){
                    if(Array.isArray(parameters[key])){
                        let thisIndex = 0;
                        for(let paramsArr of parameters[key]){
                        url += `${key}[${thisIndex}]=${paramsArr}&`;
                        thisIndex++;
                        }
                    }else{
                        url += key + '=' + parameters[key] + '&';
                    }
                    }
                    url = url.slice(0, -1);
                }
                response = await this.get(url, optionsOfRequest);
            break;
            case 'put':
                response = await this.put(url, parameters, optionsOfRequest);
            break;
            case 'delete':
                response = await this.delete(url, parameters, optionsOfRequest);
            break;
        }
        if(response.status == 900){
            // store.dispatch('saveSessionMessage', {
            //     message: 'a problem occurred with your application, but do not worry, we are already looking into it', 
            //     messageType: 'error'
            // });
            // await this.redirect('/maintance');
            // return {
            //     success: false,
            //     data: {},
            //     message: 'error',
            //     status: 900,
            //     header: {}
            // };
        }
        resultFormat.header = response.headers;
        resultFormat.data = response.data;
        resultFormat.status = response.status;
        if(response.data.message !== undefined)
            resultFormat.message = response.data.message;
        return resultFormat;
    } catch (error) {
        const defaultErrorMessage = 'unexpected error, please try again later';
        resultFormat.success = false;
        resultFormat.data = "";
        resultFormat.status = 500;
        if(error !== undefined && error.response !== undefined){
            resultFormat.data = error.response.data;
            resultFormat.status = error.response.status;
            if(error.response.data.message !== undefined)
                resultFormat.message = error.response.data.message;
            if(resultFormat.status == 419){
                store.dispatch('saveSessionMessage', {message: 'login expired, perform login again please', messageType: 'error'});
                await this.redirect('/login');
            }
        }
        if(resultFormat.message == '')
            resultFormat.message = defaultErrorMessage;
        if(resultFormat.status == 401){
            let isLogged = store.getters.isLoggedIn;
            if(isLogged)
                store.dispatch('saveSessionMessage', {message: 'authentication expired', messageType: 'error'});
            await AuthUserService.logout(true);
            await this.redirect('/login');
        }
        return resultFormat;
    }
}
requestHandler.redirect = async function goTo(url = '/'){
    urlHandler.redirectAndScroll(url);
}
requestHandler.redirectByProfile = async function redirectByProfile(){
    const routeToGo = store.getters.isLoggedIn && store.getters.isOnlyPersonProfile ? '/dashboard/profile' : '/dashboard/' + store.getters.getLoggedAs + '/' + store.getters.getUserSlug;
    requestHandler.redirect(routeToGo);
}
requestHandler.fetchOnPublicData = async function fetchOnPublicData(url = ''){
    if(url == '')
        return false;
    let gatheredData = false;
    try {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', `/data/${url}`, false);
        xhr.send();
        if (xhr.status === 200) {
            gatheredData = JSON.parse(xhr.responseText);
        }
    } catch (error) {
        return gatheredData;
    }
    return gatheredData;
}

export default requestHandler;